import { Nav, NavDropdown } from "react-bootstrap";
import { useAuth } from "react-oidc-context";

export const LoginNav = () => {
  const auth = useAuth();

  const username = (auth.user?.profile as any)?.['cognito:username'];

  if (auth.isAuthenticated) {
    return (<NavDropdown title={'Profile'}>
        <Nav.Link href="profile">Profile ({username})</Nav.Link>
        <Nav.Link onClick={auth.removeUser}>Sign out</Nav.Link>
    </NavDropdown>)
  } else {
    return (<Nav.Link onClick={() => auth.signinRedirect()}>Sign in</Nav.Link>)
  }
}